import React from "react";
import IpdaImage from '../assets/images/ipad-air.png';


function ForCorporateIpadImage() {
    return (
        <div className="plr-100 text-center">
            <div className="corporate-ipadimage d-flex justify-content-center text-center position-relative">
                <img src={IpdaImage} alt="Luxury Car Booking on iPad"/>                            
            </div>
        </div>
    );
}

export default ForCorporateIpadImage;
